import {
  GlobalSearchContactResult,
  GlobalSearchCompanyResult,
  GlobalSearchRequestResult,
  GlobalSearchTripInfo,
} from "types";
import { SearchResultTypename } from "../../../types";

const { Contact, Company, Request } = SearchResultTypename;

type SearchResult = GlobalSearchContactResult | GlobalSearchCompanyResult | GlobalSearchRequestResult;

export function getSearchResultDisplayName(searchResult: SearchResult): string {
  if (searchResult.__typename === Contact) {
    const contactResult = searchResult as GlobalSearchContactResult;
    return `${contactResult.firstName} ${contactResult.lastName}`;
  }
  
  if (searchResult.__typename === Company) {
    const companyResult = searchResult as GlobalSearchCompanyResult;
    return companyResult.name;
  }
  
  if (searchResult.__typename === Request) {
    const requestResult = searchResult as GlobalSearchRequestResult;
    if (requestResult.tripNumber) {
      return `Trip #${requestResult.orderNumber}-${requestResult.tripNumber}`;
    }
    return `Trip #${requestResult.orderNumber}`;
  }
  
  return "";
}

export function getSearchResultSecondaryInfo(searchResult: SearchResult): string | null {
  if (searchResult.__typename === Contact) {
    const contactResult = searchResult as GlobalSearchContactResult;
    const infoParts = [];
    if (contactResult.company) infoParts.push(contactResult.company);
    if (contactResult.email) infoParts.push(contactResult.email);
    if (contactResult.mobilePhone) infoParts.push(contactResult.mobilePhone);
    return infoParts.join(" • ") || null;
  }
  
  if (searchResult.__typename === Company) {
    const companyResult = searchResult as GlobalSearchCompanyResult;
    const infoParts = [];
    if (companyResult.email) infoParts.push(companyResult.email);
    if (companyResult.phoneNumber) infoParts.push(companyResult.phoneNumber);
    return infoParts.join(" • ") || null;
  }
  
  if (searchResult.__typename === Request) {
    const requestResult = searchResult as GlobalSearchRequestResult;
    return requestResult.dateString || null;
  }
  
  return null;
}

export function getSearchResultRelatedTrips(searchResult: SearchResult): GlobalSearchTripInfo[] {
  if (searchResult.__typename === Contact) {
    const contactResult = searchResult as GlobalSearchContactResult;
    return contactResult.relatedTrips || [];
  }
  
  if (searchResult.__typename === Company) {
    const companyResult = searchResult as GlobalSearchCompanyResult;
    return companyResult.relatedTrips || [];
  }
  
  // Request results don't have related trips - they are the trip themselves
  if (searchResult.__typename === Request) {
    return [];
  }
  
  return [];
}